import React, {useEffect} from "react";
import MaterialController from "./MaterialController";
import {useSnapshot} from "valtio";
import {state, materialState} from "../../state";

const MaterialInitialiser = ({activeMaterials}) => {
  
  const {materialsLocation, materialCategoryLocation} = useSnapshot(state);
  const {selectedMaterialGroup, materialSets, doubleSided} = useSnapshot(materialState);
  
  useEffect(() => {
    
    const currMaterialSet = materialSets[selectedMaterialGroup];
    
    let newTextureSet;
    let newMaterialProps;
  
    activeMaterials.forEach((item) => {
      
      const curr = item['materialName'];
      const activeMaterialData = currMaterialSet.find(mat => mat.title === curr);
      
      newTextureSet = activeMaterialData['textureSet'];
      newMaterialProps = activeMaterialData['materialProps'];
      
      const location = materialsLocation + materialCategoryLocation;
      
      MaterialController(item, newTextureSet, newMaterialProps, location, doubleSided);
      
    });
    
  }, [activeMaterials, doubleSided]);
  
}


export default MaterialInitialiser;
